import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ENTERPRISES_URL, CHARGING_SESSIONS_SUFFIX, CHARGING_SESSIONS, GET_SESSIONS_STATIC_URL } from '../../shared/constants/urls';
import { CustomStorageService } from '../custom-storage/custom-storage.service';

@Injectable({
  providedIn: 'root'
})
export class ChargingSessionsService {

  constructor(
    private readonly http: HttpClient,
    private readonly storageService: CustomStorageService) { }

  getHeader() {
    const headers = new HttpHeaders({
      authorization: 'bearer ' + this.storageService.getToken(),
    });
    return headers;
  }
  getChargingSessions() {
    const enterpriseId = this.storageService.getEnterprise()._id;
    return this.http.get(ENTERPRISES_URL + CHARGING_SESSIONS_SUFFIX);
  }
  getSessionById(id) {
    const options = {
      headers: new HttpHeaders({
        enctype: 'multipart/form-data',
        Authorization: 'bearer ' + this.storageService.getToken(),
      })
    };
    return this.http.get(CHARGING_SESSIONS + id, options);
  }

  getSessionQuery(query: string) {
    return this.http.get(GET_SESSIONS_STATIC_URL + query, { headers: this.getHeader() });
  }

  getSessions(query: string) {
    return this.http.get(CHARGING_SESSIONS + query, { headers: this.getHeader() });
  }

  getSessionsByEnterprise(query: string) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      authorization: 'bearer ' + localStorage.getItem('token'),
    });
    return this.http.get(CHARGING_SESSIONS + query, { headers });
  }

  getSessionsByUser(id) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      authorization: 'bearer ' + localStorage.getItem('token'),
    });
    return this.http.get(CHARGING_SESSIONS + '?clientId=' + id, { headers });
  }
}
